import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { IconButton } from '@material-ui/core'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { Link } from 'react-router-dom'
import imageArrayToImgContent from '../utilities/Data/imageArrayToImgContent'
import RoundedImageIcon from './RoundedImageIcon'
import FollowButton from './FollowButton'
import OwnWant from './OwnWant'
import styles from './ItemList.icss'
import Icon from './Icon'

class ItemList extends React.Component {
	render() {
		const { classes, isLoading, iconName, itemFragment, renderAfterItem, imageContent, imageCover, imageClassName, title, fitScoreTesting, subtitle, onContextClick, showOwnWant, showFollow, follow, followSet, own, want, ownSet, wantSet, showCountComments, countComments, countCommentsClick, shareClick, kudos, showKudos, kudosSet, kudosCount, ...anchorProps } = this.props // eslint-disable-line react/prop-types
		anchorProps.href = (anchorProps.onClick ? null : anchorProps.href) || null // eslint-disable-line no-script-url
		//	Use a span if no href
		const LinkComponent = !anchorProps.href ? props => <span {...props}>{props.children}</span> : Link
		const hasButtons = showOwnWant || showFollow
		const images = imageArrayToImgContent(imageContent)
		return (
			// styles.item + (isLoading ? ` ${styles.isLoading}` : '')
			<div className={classNames(styles.item, classes.root, { [styles.isLoading]: isLoading })}>
				{itemFragment || (
					<React.Fragment>
						<LinkComponent to={anchorProps.href} {...anchorProps}>
							<RoundedImageIcon
								className={classNames(styles.itemImage, imageClassName)}
								content={images}
								cover={imageCover}
								divisor={4}
							/>
						</LinkComponent>
						<LinkComponent className={styles.itemDetails} to={anchorProps.href} {...anchorProps}>
							<div className={styles.titleBar}>
								{iconName && <Icon name={iconName} className={styles.itemTypeIcon} />}
								<div className={styles.titleText}>{title}</div>
							</div>
							<span className={styles.subTitleText}>
								{Array.isArray(subtitle) ? subtitle.map(cat => (cat ? cat.charAt(0).toUpperCase() + cat.slice(1) : undefined)).join(', ') : subtitle}
							</span>
						</LinkComponent>

						{hasButtons && (
							<section className={styles.buttonContainer}>
								{showFollow && (
									<FollowButton
										follow={follow}
										followSet={followSet}
									/>
								)}
								{showOwnWant && (
									<OwnWant
										className={styles.ownWant}
										showIcons={false}
										showCounts={false}
										smallerButtons
										own={own}
										want={want}
										ownSet={ownSet}
										wantSet={wantSet}
									/>
								)}
							</section>
						)}

						{onContextClick && (
							<div className={styles.contextBtn}>
								<IconButton aria-label="Context" onClick={onContextClick}>
									<MoreVertIcon />
								</IconButton>
							</div>
						)}
					</React.Fragment>
				)}
				{renderAfterItem && renderAfterItem}
			</div>
		)
	}
}

ItemList.propTypes = {
	classes: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	imageContent: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(PropTypes.string),
		PropTypes.shape({ type: PropTypes.string, webpurl: PropTypes.string, url: PropTypes.string }),
		PropTypes.arrayOf(PropTypes.shape({ type: PropTypes.string, webpurl: PropTypes.string, url: PropTypes.string }))
	]),
	imageCover: PropTypes.bool,
	imageClassName: PropTypes.string,
	isLoading: PropTypes.bool,
	itemFragment: PropTypes.node,
	renderAfterItem: PropTypes.node,
	iconName: PropTypes.string,
	onContextClick: PropTypes.func,
	subtitle: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.string), PropTypes.string]), // eslint-disable-line react/forbid-prop-types
	title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
	showOwnWant: PropTypes.bool,
	showFollow: PropTypes.bool,
	follow: PropTypes.bool,
	followSet: PropTypes.func,
	own: PropTypes.bool,
	want: PropTypes.bool,
	ownSet: PropTypes.func,
	wantSet: PropTypes.func
}

ItemList.defaultProps = {
	classes: {},
	imageContent: [{ url: '/images/placeholder.png' }],
	imageCover: true,
	imageClassName: undefined,
	isLoading: false,
	itemFragment: undefined,
	iconName: undefined,
	renderAfterItem: undefined,
	onContextClick: undefined,
	subtitle: undefined,
	title: undefined,
	showOwnWant: false,
	showFollow: false,
	follow: false,
	followSet: undefined,
	own: false,
	want: false,
	ownSet: undefined,
	wantSet: undefined
}

export default ItemList



// WEBPACK FOOTER //
// ./src/components/ItemList.jsx